module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customer-search"
  }, [(!_vm.isDataLoaded && !_vm.hasError) ? _c('loader', {
    staticClass: "panel-loader"
  }) : _vm._e(), _vm._v(" "), (_vm.hasError) ? _c('div', {
    staticClass: "error-container alert alert-danger"
  }, [_vm._v("\n        " + _vm._s(_vm.error) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.isDataLoaded && !_vm.isEditing) ? _c('div', [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.results), function(result) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(result.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(result.name))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "glyphicon glyphicon-pencil",
      on: {
        "click": function($event) {
          _vm.edit(result.id)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "glyphicon glyphicon-trash",
      on: {
        "click": function($event) {
          _vm.remove(result.id)
        }
      }
    })])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.isDataLoaded && _vm.isEditing) ? _c('div', [_c('span', {
    staticClass: "close glyphicon glyphicon-remove",
    on: {
      "click": function($event) {
        _vm.cancelEdit()
      }
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Edit " + _vm._s(_vm.currentSearch.name))]), _vm._v(" "), _c('div', {
    staticClass: "form-group customer-search-query-wrapper"
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentSearch.name),
      expression: "currentSearch.name"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.currentSearch.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentSearch.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group customer-search-query-wrapper"
  }, [_c('label', [_vm._v("Description")]), _vm._v(" "), _c('text-area-component', {
    staticClass: "form-control",
    model: {
      value: (_vm.currentSearch.description),
      callback: function($$v) {
        _vm.currentSearch.description = $$v
      },
      expression: "currentSearch.description"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group customer-search-query-wrapper"
  }, [_c(_vm.searchMode, {
    tag: "component",
    class: _vm.searchClass,
    attrs: {
      "searchSpec": _vm.queryBuilderSpec
    },
    model: {
      value: (_vm.currentSearch.parameters),
      callback: function($$v) {
        _vm.currentSearch.parameters = $$v
      },
      expression: "currentSearch.parameters"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group customer-search-query-wrapper"
  }, [_c('toggle-switch', {
    model: {
      value: (_vm.currentSearch.shared),
      callback: function($$v) {
        _vm.currentSearch.shared = $$v
      },
      expression: "currentSearch.shared"
    }
  }, [_vm._v("Share with my team")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "search-mode btn btn-primary col-xs-3",
    on: {
      "click": function($event) {
        _vm.toggleMode()
      }
    }
  }, [_vm._v(_vm._s(_vm.toggleTo))]), _vm._v(" "), _c('button', {
    staticClass: "search-action btn btn-primary col-xs-3 pull-right",
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "search-action btn btn-primary col-xs-3 pull-right",
    on: {
      "click": function($event) {
        _vm.testSearch()
      }
    }
  }, [_vm._v("Test")])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Id")]), _c('th', [_vm._v("Name")]), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb798d40"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/SavedSearches.vue
// module id = 1125
// module chunks = 0